module.exports = __webpack_public_path__ + "img/文字.0e160d20.png";